import React, {forwardRef} from "react";

const Input = forwardRef(({className, type, ...props}, ref) => {
  return (
    <input
      type={type}
      ref={ref}
      {...props}
      className="w-full px-4 py-2 text-sm border outline-none text-slate-950 rounded-2xl focus:ring-2 focus:ring-primary disabled:text-slate-500"
    />
  );
});

Input.displayName = "Input";

export {Input};